var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"file","name":"image","accept":"image/*","capture":"environment"},on:{"change":_vm.onChangeInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }